import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { FormsModule, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { I18nModule, TranslationService } from '@spartacus/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomLandingModule } from '../../custom-landing.module';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { ToastrService } from 'ngx-toastr';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { MasterData } from 'src/app/core/model/master-data.model';
import { get } from 'http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InspectionScreeningPopUpComponent } from '../inspection-screening-pop-up/inspection-screening-pop-up.component';
import { CustomProductsService } from '../../custom-products/custom-products.service';
import { AttachInvoiceComponent } from '../attach-invoice/attach-invoice.component';


interface QualityInspectionItem {
  id: string;
  name: string;
  status: any;
  cargoAgent: any;
  cargoAgentId: string;
  screeningOperator: string;
  screeningOperatorId: string;
  agent?: any;
  batchId?: string;
  code?: string;
  formattedFineFe?: string;
  formattedFineH2o?: string;
  formattedFinePlus6p3Mm?: string;
  formattedLumpFe?: string;
  formattedLumpH2o?: string;
  formattedLumpMinus6p3Mm?: string;
  formattedTotalInspectedQty?: string;
  port?: string;
  screeningAgent?: any;
  statusLocale?: string;
  vesselName?: string;
}



@Component({
  selector: 'app-quality-inspection',
  standalone: true,
  imports: [
    NgSelectModule,
    CommonModule,
    FormsModule,
    I18nModule,
    CustomLandingModule,
    CommonModule,
    FormsModule,
    NgSelectModule,
    I18nModule,
    SharedModule,InfiniteScrollDirective
  ],
  templateUrl: './quality-inspection.component.html',
  styleUrl: './quality-inspection.component.scss',
})
export class QualityInspectionComponent implements OnInit {
  activeTab: string = 'Active';
  inspTab= 'NEW:INPROGRESS:ASSIGNED';
  selectedPort: any = [];
  selectedStatus: any = [];
  StatusList: any[] = [];
  shipmentdata: any = [];
  inspectionData: any = [];
  //portList: Port[] = [];
  navigationData: any;
  title: any;
  enableLoader: boolean = false;
  reachedToEnd: boolean = false;
  page: any;
  sidebar: boolean = true;
  loadingData: boolean = false;
  masterData: any;
  portData:any;
  showClear: boolean = false;
  searchText: string | null = null;
  portlength = 0;
  statuslength = 0;
  checkedportform: UntypedFormGroup;
  checkedstatusform: UntypedFormGroup;
 fromDetails:any; 
isAgentInvoiceActive: string = 'false';
  constructor(public modalService: NgbModal,private router: Router, private customProfileService: CustomProfileService,
     private translation: TranslationService,private customProductsService: CustomProductsService, private toastrService: ToastrService,private cd: ChangeDetectorRef,
     private fb: UntypedFormBuilder,private route: ActivatedRoute
  ) {
     this.checkedportform = this.fb.group({
      checkArray: this.fb.array([]),
    });
    this.checkedstatusform = this.fb.group({
      checkArray: this.fb.array([]),
    });
  }

  ngOnInit(): void {
     this.customProductsService.returnAgentInvoiceActive().subscribe(res=>{
      this.isAgentInvoiceActive = res;
   })

      this.translation
        .translate('breadcrumb.qualityInspection.pageTitle')
        .subscribe((res) => {
          this.title = res;
        });
      this.translation
        .translate('breadcrumb.qualityInspection.breadcrumb')
        .subscribe((res) => {
          this.navigationData = res;
        });
        this.filter();
    this.initializeData();
    const tab = this.route.snapshot.queryParamMap.get('tab');
    if (tab) {
      this.switchTab(tab);
    }
  }
filter(){
    this.route.queryParams.subscribe(params=>{
      this.fromDetails=params['from']==='details';
     })
     if(!this.fromDetails){
      this.clearAllFilter();
     }
    this.customProfileService.getports().subscribe((data)=>{
      if(data?.length){
        this.selectedPort = data;
        this.changePorts();
      }
   })
    this.customProfileService.getstatus().subscribe((data)=>{
      if(data?.length){
        this.selectedStatus = data;
        this.changeStatus();
      }
    })
    this.customProfileService.getsearch().subscribe((data)=>{
      if(data?.length){
        this.searchText = data;
      }
    })

  }
  /**
   * Initialize ports and items from service data
   * Replace with actual service calls
   */
  initializeData(): void {
     this.enableLoader = true;
    let toastshown = false;
     this.customProfileService
            .getShipmentfilters('QINSP')
            .subscribe((res: MasterData) => {
              this.enableLoader = false;
              if (res) {
                this.masterData = res;             
                this.portData = this.masterData.ports;              
                this.StatusList = this.masterData.shipmentStatus;
                this.getQualityInspectionList();
              }
              (error: any) => {               
                // this.toastrService.show('Something went wrong please contact support team.')
                this.translation
                  .translate('shipment.erroroccuredmessage')
                  .subscribe((res) => {
                    if (!toastshown) {
                      this.toastrService.show(res);
                      toastshown = true;
                    }
                  });
              };
            }); 
  }

  switchTab(tab: string): void {
    this.enableLoader = true;
    this.activeTab = tab;
    this.page = 0;
    this.reachedToEnd = false;
     if(tab=='Completed'){       
          this.inspTab = 'COMPLETED';
        }else{          
          this.inspTab = 'NEW:INPROGRESS:ASSIGNED';
        }
    this.getQualityInspectionList();
  }

 
  gotoDetails(data: any): void {
       this.customProfileService.setports(this.selectedPort);
   this.customProfileService.setstatus(this.selectedStatus);
   this.customProfileService.setsearch(this.searchText);
    this.router.navigate(['/shipmentvms/quality-details/portside/', data.batchId, data.code], { queryParams: {  tab: this.activeTab } });
  }


   changePorts() {
    if ((this.selectedPort?.length == 0 ||
        this.selectedPort?.length == undefined) &&
      (this.selectedStatus?.length == 0 ||
        this.selectedStatus?.length == undefined)) {
      this.showClear = false;
    } else {
      this.showClear = true;
    }
    this.reachedToEnd = false;   
    this.getQualityInspectionList();   
  }

  changeStatus() {
    if ((this.selectedPort?.length == 0 ||
        this.selectedPort?.length == undefined) &&
      (this.selectedStatus?.length == 0 ||
        this.selectedStatus?.length == undefined)) {
      this.showClear = false;
    } else {
      this.showClear = true;
    }
    this.reachedToEnd = false;
    this.getQualityInspectionList();
  }
  portsmobileFilter(e: any, id: any) {
      this.portlength = 1;
      const checkArray: UntypedFormArray = this.checkedportform.get(
        'checkArray',
      ) as UntypedFormArray;
      if (e.target.checked) {
        checkArray.push(new UntypedFormControl(e.target.value));
      } else {
        let i = 0;
        checkArray.controls.forEach((item: any) => {
          if (item.value === e.target.value) {
            checkArray.removeAt(i);
            return;
          }
          i++;
        });
        this.portlength = 0;
      }
      this.selectedPort = checkArray.value;
    }
  statusmobileFilter(e: any, id: any) {
    this.statuslength = 1;
    const checkArray: UntypedFormArray = this.checkedstatusform.get(
      'checkArray',
    ) as UntypedFormArray;
    if (e.target.checked) {
      checkArray.push(new UntypedFormControl(e.target.value));
    } else {
      let i = 0;
      checkArray.controls.forEach((item: any) => {
        if (item.value === e.target.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
      this.statuslength = 0;
    }
    this.selectedStatus = checkArray.value;
  }
    
  getResults(): any {
    this.closebar();
    this.enableLoader = true;
     this.getQualityInspectionList();
  }

  clearAllFilter(): any {
    this.showClear = false;
    this.selectedPort = [];   
    this.selectedStatus = [];
    this.searchText = null;
    this.customProfileService.resetportFilter();
    this.customProfileService.resetstatusFilter();
    this.customProfileService.resetsearchFilter();   
    this.customProfileService.resetTemplateData();  
     this.getQualityInspectionList();
  }

   clearFilterDataMobile(event: any): void {
    this.closebar();
    const checked = false;
    this.portData.forEach((item: any) => (item.selected = checked));
    this.StatusList.forEach((item) => (item.selected = checked));
    this.selectedPort = [];
    this.selectedStatus = [];
    this.searchText = null;
  
    this.getQualityInspectionList();
  }
  omitSpecialChar(event: any): any {
    const k = event.charCode;
    if (k === 46) {
      return false;
    }
    return this.isValidLetter(k);
  }
  isValidLetter(k: any): any {
    return (k = 47);
  }
  search() {
      this.searchText = (this.searchText ?? '').toLowerCase();
       if (this.searchText?.length >= 7) {
      this.getQualityInspectionList();
      } else if (this.searchText.length == 0) {
        this.getQualityInspectionList();
      }  
  }
   convertDateOnly(dateString: string): any {
    if (dateString) {
      return dateString.replace(/-/g, '/');
    }
  }

  getQualityInspectionList(){
    this.page =0;
     this.enableLoader = true;
      const requestParams = {
      port: this.selectedPort?.length ? this.selectedPort : '',
      currentPage: this.page,
      pageSize: 10,
      status: this.selectedStatus?.length ? this.selectedStatus : this.inspTab
    };
    let toastshown = false;
     this.customProfileService.getQualityInspectionList(requestParams,this.searchText).subscribe((res:any) => {
          this.enableLoader = false;
      if (res?.results?.length) {         
            this.inspectionData = res.results;  
              this.cd.detectChanges(); 
            console.log('quality inspection list-->', this.inspectionData);
          }else{       
            this.inspectionData = [];
          }
        }, (err: any) => {
           // this.toastrService.show('Quality inspection list is having some error.')
             this.translation
            .translate('shipment.erroroccuredmessage')
            .subscribe((res) => {
              if (!toastshown) {
                this.toastrService.show(res);
                toastshown = true;
              }
            });
            this.enableLoader=false
        });
      
  }

   onScrollGrid(): any {
    console.log('onScrollGrid');
    if (!this.loadingData) {
      this.loadMoreData();
    }
  }

  loadMoreData(){
    console.log('loding more data');

    this.loadingData = true;
    let toastshown = false;

    // if (!this.reachedToEnd) {
    //   setTimeout(() => {
        //this.enableLoader = true;
        this.page+=1
        const requestParams = {
          port: this.selectedPort?.length ? this.selectedPort : '',
          currentPage: this.page,
          pageSize: 10,
          status: this.selectedStatus?.length ? this.selectedStatus : this.inspTab
        
        }
       
          //this.enableLoaderScoll=true
          this.customProfileService.getQualityInspectionList(requestParams,this.searchText).subscribe((res:any) => {
            this.loadingData = false;
            if(res.results?.length){
              this.loadingData = false;
              this.inspectionData = res.results;
              this.inspectionData = this.inspectionData.concat(res.results);  
             this.enableLoader = false;
            }else{
               this.reachedToEnd = true;
              this.enableLoader = false;
            }
          }, (err: any) => {
            this.translation
              .translate('shipment.erroroccuredmessage')
              .subscribe((res) => {
                if (!toastshown) {
                  this.toastrService.show(res);
                  toastshown = true;
                }
              });
                this.enableLoader = false;
           
          })
    
  }
  filtersidebar() {
    this.sidebar = false;
  }
   closebar() {
    this.sidebar = true;
  }

   private getDateYYYYMMDD(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
  }

   donwloadReport(reportType:string){
    let toastshown = false;
    this.enableLoader = true;
      this.customProfileService.exportReport(reportType).subscribe(
        (response:any) => {
          if (response.status == 'success') {
            const ref = document.createElement('a');
            ref.href = `data:application/xlsx;base64,${response.code}`;
            if (reportType === 'quality_report') {
              ref.download = `CCIC_Inspection_Quality_Daily_Report-${this.getDateYYYYMMDD()}.xlsx`;
            } 
            ref.click();
            this.enableLoader = false;
            this.translation
              .translate('shipment.downloaddoc')
              .subscribe((res) => {
                if (!toastshown) {
                  this.toastrService.show(res);
                  toastshown = true;
                }
              });
          } else {
            this.enableLoader = false;
            this.toastrService.show(response.status);
          }
        },
        (err:any) => {
          this.enableLoader = false;
          // this.toastrService.show('Download unsuccessful, please contact support team.');
          this.translation
            .translate('shipment.downloadunsuccess')
            .subscribe((res) => {
              if (!toastshown) {
                this.toastrService.show(res);
              }
            });
        },
      );
  }
openCargoAgentPopup(userType: string, shipdata?: any){
      const modalRef = this.modalService.open(InspectionScreeningPopUpComponent, {
        centered: true,
        size: 'lg',
      });
      modalRef.componentInstance.userType = userType;
      const members = userType === 'screening_operator'
        ? shipdata?.screeningAgent?.members || shipdata?.screeningAgent?.members || []
        : shipdata?.cargoAgent?.members || [];
  
      const agentName = userType === 'screening_operator'
        ? shipdata?.screeningAgent?.name 
        : shipdata?.cargoAgent?.name;
  
      modalRef.componentInstance.cargoAgentMembers = members;
      modalRef.componentInstance.agentName = agentName;
     }

      openInvoices(data: any): void { 
        const modalref = this.modalService.open(AttachInvoiceComponent, {
              centered: true,
              size: 'lg',
              backdrop: 'static',
              keyboard: false,
            });
            modalref.componentInstance.display='invoices';
            modalref.componentInstance.batchData = data;
            modalref.componentInstance.useCaseType ='QUALITYINVOICE_UC3';
      }
}
